import React, { useState, useEffect, Suspense, lazy } from 'react';
import { Routes, Route, useLocation, Navigate, Outlet } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Home from './pages/Home';
import Join from './pages/Join'; // Updated path to Join component
import Login from './pages/Login'; // Updated path to Login component
import Dashboard from './pages/Dashboard'; // Ensure this path is correct
import ForgotPassword from './pages/ForgotPassword';
import ManageProfile from './pages/ManageProfile'; // Assuming you have this page
import Navbar0 from './components/Navbar0';
import Loader from './components/Loader';
import { UserProvider } from './context/UserContext';
import CookieBanner from './components/CookieBanner'; // Import your cookie banner component
import Profile from './pages/Profile';
import { CssBaseline, GlobalStyles } from '@mui/material';
import Feed from './components/Feed';
import Navbar1 from './components/Navbar1';
import Footer from './components/Footer';
import AIDetect from './pages/AIDetect';  // Updated to match the correct file name
import Questions from './pages/Questions';
import NotFound from './pages/NotFound';
import ProtectedRoute from './components/ProtectedRoute';
import { Container } from '@mui/material';
import Support from './pages/Support';
import { Link } from 'react-router-dom';
import AllQuestions from './pages/AllQuestions';
import Pages from './pages/Pages';
import Options from './pages/Options';
import Hardware from './pages/Hardware';
import Solutions from './pages/Solutions';
import Pricing from './pages/Pricing';
import AskQuestion from './pages/AskQuestion';
import EditProfileForm from './pages/EditProfileForm';
import PremiumAccess from './pages/PremiumAccess';
import Privacy from './pages/Privacy';
import QuestionDetail from './pages/QuestionDetail';
import ResetPassword from './pages/ResetPassword';
import supabaseClient from './supabaseClient';
import { Box, Typography, Button } from '@mui/material';
import Space from './pages/Space';
import ServerQuestions from './pages/ServerQuestions';
import ScanHistory from './pages/ScanHistory';
import Chatbot from './components/ChatBot';
import Reports from './pages/Reports';
import PrivateRoute from './components/PrivateRoute';
import Marketplace from './pages/Marketplace';  // You'll need to create this component
import Settings from './pages/Settings';
import Feed2 from './pages/Feed2';  // Add this import
import Card from './components/Card';  // Make sure this import exists
import ProductDetails from './components/ProductDetails';
import FAQ from './pages/FAQ';
import Mobile from './pages/Mobile';
import RemoteSupport from './pages/RemoteSupport';
import CookieConsent from './components/CookieConsent';
import Question from './pages/Question';
import Ticket from './pages/Ticket';
import Orders from './pages/Orders';
import ViewQuestion from './pages/ViewQuestion';
import ReportView from './pages/ReportView';
import Loading, { AppLoader } from './components/Loading';
import { LoadingProvider } from './context/LoadingContext';
import FileScan from './pages/FileScan';
import Chat from './pages/Chat';
import AI from './pages/AI'; // Add this import
import Messenger from './pages/Messenger';
import { ThemeProvider, createTheme } from '@mui/material';
import Guidelines from './pages/Guidelines'; // Add this import
import KnowledgeBase from './pages/KnowledgeBase';
import UpdatePassword from './pages/UpdatePassword';
import ContactUs from './pages/ContactUs';
import Docs from './pages/Docs';
import Signup from './pages/Signup';
import Contact from './pages/Contact';
import About from './pages/About';
import Blog from './pages/Blog';
import Services from './pages/Services';
import ProblemDetail from './pages/ProblemDetail';
import AIChat from './components/AIChat';
import Under from './pages/Under';
import HelpCenter from './pages/HelpCenter';
import Admin from './pages/Admin';  // Add this import
import FAQ2 from './pages/FAQ2';
import Branchs from './pages/branchs';  // Update to match file name case
import Premium from './pages/Premium'; // Import the Premium page
import Expertconsultation from './pages/Expertconsultation'; // Import Expert Consultation page
import Adwati from './pages/adwati';
import Numbers from './pages/numbers';
import Complaints from './pages/complaints';
import Swalhi from './pages/swalhi';
import Consultation from './pages/consultation';
import BookConfirm from './pages/bookconfirm';
import Diagnostics from './pages/Diagnostics';
import Terms from './pages/Terms';
import Info from './components/info'; // Import the Info component
import Issues from './components/usersissue/Issues'; // Import the Issues component
import ViewIssue from './components/usersissue/ViewIssue';
import IssuesList from './components/usersissue/IssuesList';
import AIdiagnostics from './pages/ai-diagnostics';
import RepairGuide from './pages/repair-guide';
import Parts from './components/parts/part/Parts';
import AdminParts from './components/parts/part/AdminParts';
import PartDetails from './components/parts/part/PartDetails';
import Scan from './pages/scan';
import Cart from './components/parts/part/Cart';
import SmartSearch from './pages/SmartSearch';
import Mission1 from './pages/mission';
import VideoConsultation from './pages/video-consultation';
import PartsMarketplace from'./pages/parts-marketplace';
import BMC from './pages/BMC'; // Import the BMC component
import Works from './pages/works';
import ClarifaiAnalyzer from './components/AI/clarifai';
import Costs from './pages/Costs'; // Import the Costs component
const ProtectedLayout = () => {
  const { user, loading } = useAuth();
  
  if (loading) {
    return <div>Loading...</div>;
  }
  
  if (!user) {
    return <Navigate to="/login" />;
  }
  
  return (
    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <Navbar1 />
      <div style={{ 
        flex: 1, 
        padding: '24px',
        backgroundColor: '#f5f5f5',
        marginTop: '64px'
      }}>
        <Outlet />
      </div>
      <Footer />
    </div>
  );
};

// No Page Found Component
const NoPage = () => {
  return (
    <Box 
      sx={{ 
        display: 'flex', 
        flexDirection: 'column',
        alignItems: 'center', 
        justifyContent: 'center',
        minHeight: '100vh',
        bgcolor: '#f5f5f5',
        p: 3,
        textAlign: 'center'
      }}
    >
      <Typography variant="h3" sx={{ mb: 2, color: '#333' }}>
        404 - Page Not Found
      </Typography>
      <Typography variant="body1" sx={{ mb: 4, color: '#666' }}>
        The page you're looking for doesn't exist or has been moved.
      </Typography>
      <Button 
        variant="contained"
        onClick={() => window.location.href = '/space'}
        sx={{
          bgcolor: '#00693C',
          color: 'white',
          '&:hover': { bgcolor: '#005731' }
        }}
      >
        Go to Space Dashboard
      </Button>
    </Box>
  );
};

// Lazy load your pages
const QuestionsLazy = lazy(() => import('./pages/Questions'));
const HomeLazy = lazy(() => import('./pages/Home'));
const HomefrLazy = lazy(() => import('./pages/Homefr'));
const SmartSearchLazy = lazy(() => import('./pages/SmartSearch'));
const AboutLazy = lazy(() => import('./pages/About'));
const LoginLazy = lazy(() => import('./pages/Login'));
const RegisterLazy = lazy(() => import('./pages/Register'));
const AskQuestionLazy = lazy(() => import('./pages/AskQuestion'));

// Create a wrapper component for the Chat
const ChatWrapper = () => {
  const location = useLocation();
  
  // List of paths where chat should not appear
  const excludedPaths = ['/', '/login', '/join', '/signup', '/register'];
  
  // Check if current path is in excluded list
  const shouldShowChat = !excludedPaths.includes(location.pathname);

  return shouldShowChat ? <Chat /> : null;
};

// Create theme (you can customize this based on your needs)
const theme = createTheme({
  palette: {
    mode: 'light', // or 'dark'
    primary: {
      main: '#2196f3', // customize your primary color
    },
  },
});

function App() {
  const [showCookieBanner, setShowCookieBanner] = useState(true);
  const location = useLocation();
  const [showFooter, setShowFooter] = useState(true);
  
  // List of paths where chat should not appear
  const excludedPaths = ['/', '/login', '/join', '/signup', '/register'];
  
  // Check if current path is in excluded list
  const authPaths = ['/login', '/join'];
  const noFooterPaths = [...authPaths, '/']; // Added home path to hide footer
  const isAuthPath = authPaths.includes(location.pathname);
  const showCookieConsent = location.pathname !== '/';

  useEffect(() => {
    // Hide footer on smartsearch and about pages
    setShowFooter(!["/smartsearch", "/about"].includes(location.pathname));
  }, [location]);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <LoadingProvider>
        <AuthProvider>
          <UserProvider>
            <Suspense fallback={<Loading overlay={true} />}>
              <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
                <Routes>
                {/* Public routes */}
              <Route path="/" element={<HomeLazy />} />
              <Route path="/fr" element={<HomefrLazy />} />
              <Route path="/smartsearch" element={<SmartSearchLazy />} />
              <Route path="/about" element={<AboutLazy />} />
              <Route path="/login" element={<LoginLazy />} />
              <Route path="/join" element={<Join />} />

              {/* Premium page without Layout */}
              <Route path="/premium" element={<Premium />} />

              {/* Protected routes with shared layout */}
              <Route element={<ProtectedLayout />}>
                <Route 
                  path="/dashboard" 
                  element={
                    <ProtectedRoute>
                      <Container maxWidth="lg">
                        <Dashboard />
                      </Container>
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="/feed" 
                  element={
                    <ProtectedRoute>
                      <Feed />
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="/allquestions" 
                  element={
                    <ProtectedRoute>
                      <AllQuestions />
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="/ai-detect" 
                  element={
                    <PrivateRoute>
                      <AIDetect />
                    </PrivateRoute>
                  } 
                />
                <Route 
                  path="/profile" 
                  element={
                    <ProtectedRoute>
                      <Profile />
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="/card" 
                  element={
                    <ProtectedRoute>
                      <Card />
                    </ProtectedRoute>
                  } 
                />
              </Route>

              {/* Add these new routes */}
              <Route path="/pages" element={<Pages />} />
              <Route path="/options" element={<Options />} />
              <Route path="/hardware" element={<Hardware />} />
              <Route path="/scan" element={<Suspense fallback={<Loading overlay={true} />}><Box sx={{ minHeight: '100vh' }}><Scan /></Box></Suspense>} />
              <Route path="/solutions" element={<Solutions />} />
              <Route path="/pricing" element={<Pricing />} />
              <Route path="/expertconsultation" element={<Expertconsultation />} />

              {/* Question related routes */}
              <Route path="/ask-question" element={<AskQuestionLazy />} />
              <Route path="/question/:id" element={<QuestionDetail />} />

              {/* User management routes */}
              <Route path="/manage-profile" element={<ManageProfile />} />
              <Route path="/edit-profile" element={<EditProfileForm />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />

              {/* Additional pages */}
              <Route path="/premium-access" element={
                <PrivateRoute>
                  <PremiumAccess />
                </PrivateRoute>
              } />
              <Route path="/privacy" element={<Privacy />} />

              {/* 404 and catch-all */}
              <Route path="/404" element={<NotFound />} />
              <Route path="/support" element={<Support />} />
              <Route path="/space" element={<Space />} />
              <Route path="/server-questions" element={<ServerQuestions />} />
              <Route 
                path="/scan-history" 
                element={
                  <PrivateRoute>
                    <ScanHistory />
                  </PrivateRoute>
                } 
              />
              <Route 
                path="/reports" 
                element={
                  <PrivateRoute>
                    <Reports />
                  </PrivateRoute>
                } 
              />
              <Route 
                path="/marketplace" 
                element={
                  <PrivateRoute>
                    <Marketplace />
                  </PrivateRoute>
                } 
              />
              <Route path="/settings" element={<Settings />} />
              <Route path="/feed2" element={<Feed2 />} />  {/* Add this route */}
              <Route path="/product/:id" element={<ProductDetails />} />
              <Route path="/FAQ" element={<FAQ />} />
              <Route path="/mission" element={<Mission1 />} />
              <Route path="/video-consultations" element={<VideoConsultation />} />
              <Route path="/solution" element={<Solutions />} />
              <Route path="/mobile" element={<Mobile />} />
              <Route path="/remotesupport" element={<RemoteSupport />} />
              <Route path="/questions" element={<QuestionsLazy />} />
              <Route path="/question" element={<Question />} />
              <Route path="/question/view/:id" element={<ViewQuestion />} />
              <Route path="/ticket/:ticketId" element={<Ticket />} />
              <Route path="/card" element={<Card />} />
              <Route path="/orders" element={<Orders />} />
              <Route path="/report-view/:id" element={<ReportView />} />
              <Route path="/file-scan" element={<FileScan />} />
              <Route path="/scanhistory" element={<ScanHistory />} />
              <Route path="/reports" element={<Reports />} />
              <Route path="/fast-scan" element={<FileScan />} />
              <Route path="/fastscan" element={<FileScan />} />
              <Route path="/FAST SCAN" element={<FileScan />} />
              <Route path="/chat" element={<AIChat />} />
              <Route path="/ai" element={<AI />} />
              <Route path="/messenger" element={<Messenger />} />
              <Route path="/guidelines" element={<Guidelines />} />
              <Route path="/knowledgebase" element={<KnowledgeBase />} />
              <Route path="/update-password" element={<UpdatePassword />} />
              <Route path="/contact" element={<ContactUs />} />
              <Route path="/docs" element={<Docs />} />
              <Route path="/parts-marketplace" element={<PartsMarketplace />} />
              <Route path="/signup" element={<Signup />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/mission" element={<mission />} />
              <Route path="/about" element={<About />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/services" element={<Services />} />
              <Route path="/problem/:id" element={<ProblemDetail />} />
              <Route path="/aichat" element={<AIChat />} />
              <Route path="/under" element={<Under />} />
              <Route 
                path="/help/*" 
                element={<HelpCenter />} 
              />
              <Route path="/admin" element={<Admin />} />  {/* Add this route */}
              <Route path="/faq2" element={<FAQ2 />} />
              <Route path="/branchs" element={<Branchs />} />
              <Route path="/adwati" element={<Adwati />} />
              <Route path="/numbers" element={<Numbers />} />
              <Route path="/complaints" element={<Complaints />} />
              <Route path="/swalhi" element={<Swalhi />} />
              <Route path="/consultation" element={<Consultation />} />
              <Route path="/bookconfirm" element={<BookConfirm />} />
              <Route path="/diagnostics" element={<Diagnostics />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/info" element={<Info />} /> {/* Add route for Info component */}
              <Route path="/issues" element={<Issues />} /> {/* Add route for Issues component */}
              <Route path="/issues/view/:issueId" element={<ViewIssue />} />
              <Route path="/issues/list" element={<IssuesList />} />
              <Route path="/ai-diagnostics" element={<AIdiagnostics />} />
              <Route path="/repair-guides" element={<RepairGuide />} />
              <Route path="/parts" element={<Parts />} />
              <Route path="/parts/admin" element={<AdminParts />} />
              <Route path="/parts/:id" element={<PartDetails />} />
              <Route path="/parts/cart" element={<Cart />} />
              <Route path="/smartsearch" element={<SmartSearch />} />
              <Route path="/bmc" element={<BMC />} />
              <Route path="/howitwork" element={<Works />} />
              <Route path="/hardware-analysis" element={<ClarifaiAnalyzer />} />
              <Route path="/costs" element={<Costs />} /> {/* Add route for Costs/Financial Plan page */}
              <Route path="*" element={<NoPage />} />
                </Routes>
                {showCookieConsent && <CookieConsent />}
                {showFooter && <Footer />}
              </Box>
              {/* ChatWrapper will handle the floating chat visibility */}
              <ChatWrapper />
            </Suspense>
          </UserProvider>
        </AuthProvider>
      </LoadingProvider>
      
    </ThemeProvider>
  );
}

// Global styles
const globalStyles = {
  '@global': {
    'html, body': {
      margin: 0,
      padding: 0,
      height: '100%',
      backgroundColor: '#f5f5f5',
    },
    '#root': {
      minHeight: '100vh',
    },
  },
};

export default App;
